import pick from 'lodash/pick';

import { createContexts } from '../../utils';

import type { SnowplowSchemaName } from '../../schemas';
import type { EventDefinition } from '../../types';

export const landing_page_action: EventDefinition = {
  getData: (action, eventData = {}) => ({
    type: action,
    ...pick(eventData, ['contentAvailable', 'whatsNewTimeBucket']),
  }),
  addContexts: ({ eventData } = {}) => {
    const definedEntities = [
      'card',
      'supported_rival',
      'board',
      'insight',
      'battlecard',
    ].filter((entity) => entity in (eventData || {}));

    return createContexts(definedEntities as SnowplowSchemaName[], {
      eventData,
    });
  },
};
